import { render, staticRenderFns } from "./Instruction.vue?vue&type=template&id=4fc3c5a4&scoped=true&"
import script from "./Instruction.js?vue&type=script&lang=js&"
export * from "./Instruction.js?vue&type=script&lang=js&"
import style0 from "./Instruction.scss?vue&type=style&index=0&id=4fc3c5a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc3c5a4",
  null
  
)

export default component.exports